module.exports = __webpack_public_path__ + "img/report-8.142b8779.jpg";